import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { IssueCardStackRoutes, IssueCardStackScreenProps } from './type';
import { IssueCardWebZeroScreen } from './IssueCardWebZero.screen';
import { IssueCardNativeZeroScreen } from './IssueCardNativeZero.screen';

export const IssueCardMain: React.FC<IssueCardStackScreenProps<IssueCardStackRoutes.Main>> = ({ navigation, route }) => {
  const { onLayout, onData, account, tab, record, func, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <IssueCardNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        account={account}
        tab={tab}
        record={record}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <IssueCardWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      onData={onData}
      account={account}
      tab={tab}
      record={record}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
    />
  );
};
